var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMuseumBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "museum",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 171.47 126.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "b54242d1-e5ab-4cdf-bd21-1bd148e435ad",
    "data-name": "border",
    d: "M.34,67.1,33.4,56.17l-.87-1.58s1.7-1.94,1.78-2.64,0-11.41,0-11.41h5.16v-7h4.6V26.47h5.18V20h4.93v-7h4.47V7H63.7L63.57.41l8.7-.16V6.53l4.74,0,0,6.87h5v6.49h5.51v6.6h5.12V33h5v6.52h4.91v11.1l2.7,4h-2.1V68l61.64,10.87L161,82.37s.11,32.84.22,32.46,4.53,1.32,5.39,2.58,3.42-.33,4.3,1.54-.22,5-1.43,5.22-137.5,2-137.5,2-.23-1.66-1-1.67H3.12V71.06H.26Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuseumBorder);
export default __webpack_public_path__ + "static/media/museum-border.1c61c369.svg";
export { ForwardRef as ReactComponent };